module.exports = __webpack_public_path__ + "static/logo-de81f78546a6311b5a99238bc2955455.png";